import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, FlexBox, SvgIcon, useTheme } from '@kis-technologies/kis-ui';
import { Key } from '../styled';
import { NumPadProps, KeyProps } from '../types';

/**
 * Virtual NumPad to type in digits
 */

export const NumPad = (props: NumPadProps) => {
  const theme = useTheme();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    const value = e.currentTarget.value;

    if (props.onClick) props.onClick(e, value);
  };
  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Prevent the element from stealing focus from the input field
    event.preventDefault();
  };

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyBoardClick, true);
    return () => {
      document.removeEventListener('keydown', handleKeyBoardClick, true);
    };
  });

  const handleKeyBoardClick = async (event: any) => {
    const value = event.key;
    const code = event.keyCode;
    if (props.onClick) {
      if ((event.ctrlKey || event.metaKey) && code === 86) {
        const text = await navigator.clipboard.readText();
        props.onClick(event, text);
      } else if ((code >= 48 && code <= 57) || (code >= 96 && code <= 105)) {
        props.onClick(event, value);
      } else if (code === 8) {
        props.onClick(event, 'delete');
      }
    }
  };

  const keyProps: KeyProps = {
    appearance: 'white',
    customSize: 'giant',
    width: '240px',
    radius: 'subtle',
    fontFamily: theme?.typography?.fontFamily,
    onClick: handleClick,
    onMouseDown: handleMouseDown
  };

  const { t } = useTranslation();

  return (
    <FlexBox direction="column" gutter={2} flexOverride="none">
      {/* NumPad First Row */}
      <Stack>
        <Key value="1" {...keyProps}>
          1
        </Key>
        <Key value="2" {...keyProps}>
          2
        </Key>
        <Key value="3" {...keyProps}>
          3
        </Key>
      </Stack>

      {/* NumPad Second Row */}
      <Stack>
        <Key value="4" {...keyProps}>
          4
        </Key>
        <Key value="5" {...keyProps}>
          5
        </Key>
        <Key value="6" {...keyProps}>
          6
        </Key>
      </Stack>
      <Stack>
        <Key value="7" {...keyProps}>
          7
        </Key>
        <Key value="8" {...keyProps}>
          8
        </Key>
        <Key value="9" {...keyProps}>
          9
        </Key>
      </Stack>

      {/* NumPad Third Row */}
      <Stack>
        <Key value="clear" {...keyProps}>
          {t('commonText.clear')}
        </Key>
        <Key value="0" {...keyProps}>
          0
        </Key>
        <Key data-testid="delete" value="delete" {...keyProps}>
          <SvgIcon name="delete" />
        </Key>
      </Stack>
    </FlexBox>
  );
};
